module.exports = __webpack_public_path__ + "static/img/header.afda23ee.png";